// components
import Iconify from '../../../components/Iconify';
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;
const iconify = (name) => <Iconify icon={name} width={22} height={22} />;

const ICONS = {
  dashboard: getIcon('ic_dashboard'),
  user: getIcon('ic_user'),
  analytics: getIcon('ic_analytics'),
  ecommerce: getIcon('ic_ecommerce'),
  courses: getIcon('ic_courses'),
};

export function getNavConfig(role, counts = {}) {
  if (role === 'EXPERT') {
    return [
      {
        subheader: '',
        items: [
          { title: 'Hovuz', path: '/dashboard/expert/available', icon: iconify('solar:inbox-bold-duotone'), count: counts.available || 0 },
          { title: 'Tayinlangan', path: '/dashboard/expert/essays', icon: iconify('solar:clipboard-check-bold-duotone'), count: counts.assigned || 0 },
          { title: 'Tekshirilganlar', path: '/dashboard/expert/reviewed', icon: iconify('solar:check-circle-bold-duotone') },
          { title: 'Kartalar', path: '/dashboard/expert/cards', icon: iconify('solar:card-2-bold-duotone') },
          { title: 'Profil', path: '/dashboard/expert/profile', icon: iconify('solar:user-circle-bold-duotone') },
        ],
      },
    ];
  }

  // ADMIN
  const pendingApps = counts.pendingApplications || 0;
  const pendingWithdrawals = counts.pendingWithdrawals || 0;

  return [
    {
      subheader: '',
      items: [
        { title: 'Bosh sahifa', path: '/dashboard/home', icon: ICONS.dashboard },
        { title: 'Analitika', path: '/dashboard/analytics', icon: ICONS.analytics },

        {
          title: 'Esselar',
          icon: ICONS.ecommerce,
          children: [
            { title: 'Barcha esselar', path: '/dashboard/essays' },
            { title: 'Sharhlar', path: '/dashboard/reviews' },
            // { title: "AI o'rgatish", path: '/dashboard/training' },
          ],
        },

        {
          title: 'Mavzular',
          icon: iconify('solar:notebook-bookmark-bold-duotone'),
          children: [
            { title: "Mavzular ro'yxati", path: '/dashboard/topics' },
            { title: 'Mavzu turlari', path: '/dashboard/topic-categories' },
            { title: 'Mavzusiz esselar', path: '/dashboard/untagged-essays' },
          ],
        },

        {
          title: 'Foydalanuvchilar',
          icon: ICONS.user,
          count: pendingApps,
          children: [
            { title: 'Ekspertlar', path: '/dashboard/experts' },
            { title: "O'quvchilar", path: '/dashboard/students' },
            { title: 'Referallar', path: '/dashboard/referrals' },
            { title: 'Arizalar', path: '/dashboard/applications', count: pendingApps },
          ],
        },

        {
          title: 'Moliya',
          icon: iconify('solar:wallet-money-bold-duotone'),
          count: pendingWithdrawals,
          children: [
            { title: 'Tariflar', path: '/dashboard/tariffs' },
            { title: "To'lovlar", path: '/dashboard/payments' },
            { title: 'Pul yechish', path: '/dashboard/withdrawals', count: pendingWithdrawals },
          ],
        },

        { title: 'Sozlamalar', path: '/dashboard/settings', icon: iconify('solar:settings-bold-duotone') },
        {
          title: 'Kurslar',
          icon: ICONS.courses,
          path: '/dashboard/courses',
        },
        {
          title: 'AI Qoidalari',
          icon: iconify('solar:shield-check-bold-duotone'),
          children: [
            { title: 'Qoidalar', path: '/dashboard/ai-review-rules' },
            { title: 'Kategoriyalar', path: '/dashboard/ai-review-rule-categories' },
          ],
        },
        { title: "Takliflar", path: '/dashboard/feedbacks', icon: iconify('solar:chat-square-like-bold-duotone') },
      ],
    },
  ];
}

// Default export for backward compatibility
const navConfig = [
  {
    subheader: '',
    items: [
      { title: 'Bosh sahifa', path: '/dashboard/home', icon: ICONS.dashboard },
      { title: 'Essalar', path: '/dashboard/essays', icon: ICONS.ecommerce },
      { title: 'Ekspertlar', path: '/dashboard/experts', icon: ICONS.user },
      { title: "O'quvchilar", path: '/dashboard/students', icon: ICONS.analytics },
      { title: 'Mavzular', path: '/dashboard/topics', icon: ICONS.ecommerce },
      { title: 'Tariflar', path: '/dashboard/tariffs', icon: ICONS.analytics },
    ],
  },
];

export default navConfig;
